module.exports = __webpack_public_path__ + "media/react/app_submitter/components/PhotoReader/assets/cancel-d4f8e6c676b28cff7be4785dcb04553e.png";